// devices.has_panic_button en tres estados (decisión de Daniel, 19-oct):
// true = tiene botón (su código 5 cuenta como pánico en los informes),
// false = no es botón (tampoco alerta en vivo), null = sin revisar (alerta en
// vivo pero no cuenta en los informes).
export type PanicButton = boolean | null;

// value del <select> ("" = sin revisar).
export const PANIC_BUTTON_OPTIONS = [
  { value: "true", label: "Sí" },
  { value: "false", label: "No" },
  { value: "", label: "Sin revisar" },
] as const;

// setValueAs del select: el texto de la opción → true / false / null.
export const parsePanicButton = (v: unknown): PanicButton =>
  v === true || v === "true" ? true : v === false || v === "false" ? false : null;
